<template>
  <fragment>
    <template>
      <v-row>
        <div class="loja-config">
          <v-row>
            <v-col>
              <h1 class="cookies-text mb-n2">Configurações / Marketplace</h1>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-divider></v-divider>
            </v-col>
          </v-row>
        </div>
        <v-col cols="8" class="mt-10">
          <RegistrationData />
          <BankData />
          <AddictionalSettings />
        </v-col>
        <v-col cols="4" class="mt-10">
          <Theme />
          <Marketplace />
          <Sales />
        </v-col>
      </v-row>
    </template>
    <RegistrationActions
      :loader="$marketplace.cadastro.loading"
      :actions="actions"
    />
    <ModalConfirmacao
      :textModal="$marketplace.text"
      :funcaoModal="$marketplace.funcao"
      @updateTable="$marketplace.funcaoRemover"
    />
    <FrequentlyQuestionsDialog />
    <SocialMediaDialog
      :redeEdit="$marketplace.social_media"
      :redeIdx="$marketplace.social_mediaIdx"
    />
    <ContactDialog
      :contatoEdit="$marketplace.contato"
      :contatoIdx="$marketplace.contatoIdx"
    />
    <ModalVisualizarImagem :image="$marketplace.visualizarImagem" />
  </fragment>
</template>

<script>
import RegistrationData from "@/components/configuracoes/marketplace/RegistrationData.vue";
import BankData from "@/components/configuracoes/marketplace/BankData.vue";
import Theme from "@/components/configuracoes/marketplace/Theme.vue";
import AddictionalSettings from "@/components/configuracoes/marketplace/AddictionalSettings.vue";
import FrequentlyQuestionsDialog from "@/components/configuracoes/marketplace/AddictionalSettings/FrequentlyQuestionsDialog.vue";
import SocialMediaDialog from "@/components/configuracoes/marketplace/AddictionalSettings/SocialMediaDialog.vue";
import ContactDialog from "@/components/configuracoes/marketplace/AddictionalSettings/ContactDialog.vue";
import ModalConfirmacao from "@/components/global/modal-confirmacao.vue";
import ModalVisualizarImagem from "@/components/global/modal-visualizar-imagem.vue";
import RegistrationActions from "@/components/global/RegistrationActions.vue";
import Marketplace from "@/views/configuracoes/Marketplace.vue";
import configMarketplaceMixins from "@/mixins/configMarketplace.mixins.js";
import Sales from "@/components/configuracoes/marketplace/Sales.vue";
export default {
  name: "MarketplaceSettings",
  metaInfo: {
    title: "Marketplace/Gerenciar | Adicionar/Editar | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Marketplace/Gerenciar | Adicionar/Editar | ElevenTickets",
      },
    ],
  },
  mixins: [configMarketplaceMixins],
  components: {
    Marketplace,
    RegistrationData,
    BankData,
    Theme,
    AddictionalSettings,
    RegistrationActions,
    ModalConfirmacao,
    FrequentlyQuestionsDialog,
    SocialMediaDialog,
    ContactDialog,
    ModalVisualizarImagem,
    Sales,
  },
  data() {
    return {
      tabStore: 0,
      actions: [
        {
          name: "Salvar",
          action: () => this.$marketplace.validarCadastro(),
        },
        {
          name: "Cancelar",
          action: () => {
            this.$axios.rota("/home");
            location.reload();
          },
        },
      ],
    };
  },
  methods: {
    cancelAction() {
      if (this.$axios.getLocal("oe_user_info")?.data?.user_type === "admin")
        return this.$axios.rota("/lojas/gerenciar");
      return this.$axios.rota("/home"), location.reload();
    },
  },
  mounted() {
    this.$marketplace.getConfigMarketplace();
    this.$config.getBancos();
    if (
      this.$loja_gerenciar.lojaAddOrEdit == "edit" ||
      this.$route.params.type == "editar"
    ) {
      this.$loja_gerenciar.sequenciador = this.$route.query.loja;
      this.$loja_gerenciar.getFormasPagLoja(this.$loja_gerenciar.sequenciador);
    }
    if (this.$axios.getLocal("oe_user_info")?.data?.user_type === "admin") {
      this.$loja_gerenciar.getTipoTaxas();
    }
    if (this.$route.params.type === "editar" && this.$route.params.id) {
      this.$loja_gerenciar.lojaAddOrEdit = "edit";
      this.$loja_gerenciar.getLoja(this.$route.params.id);
    }
    // this.$pessoas_agentes.getAgentes();
  },
  destroyed() {
    this.$loja_gerenciar.limpaFormularioDeLoja();
  },
};
</script>
<style scoped>
.cookies-text {
  font-size: 1em;
  width: 487px;
  align-self: flex-start;
  margin-top: 20px;
  margin-left: 20px;
}

.config-plus {
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
}

.loja-config {
  width: 100%;
  align-items: center;
  flex-direction: column;
  margin: auto;
}
</style>
